<template>
  <a-card class="m-display-flex flex-column nowrap">
    <span slot="title">PO Create Form</span>
    <a-steps :current="current" status="process">
      <a-step title="Information" />
      <a-step title="PO Detail" />
      <a-step title="Approval" />
    </a-steps>
    <div class="steps-content flex-1">
      <keep-alive>
        <component class="flex-1" :is="steps[current].content" :ref="stepRef" v-bind="stepProps"></component>
      </keep-alive>
    </div>
    <template class="ant-card-actions" slot="actions">
      <div class="steps-action">
        <a-button v-if="current < steps.length - 1" type="primary" :loading="btnLoading" @click="next">Next</a-button>
        <a-button
          :loading="btnLoading"
          v-if="current == steps.length - 1"
          type="primary"
          @click="validate"
        >Save</a-button>
        <a-button v-if="current>0" @click="prev">Previous</a-button>
      </div>
    </template>
  </a-card>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import Informasi from "./steps/InformasiPo.vue";
import DetailPembelian from "./steps/DetailPembelianPo.vue";
import Approval from "./steps/Persetujuan.vue";
import shortingArray from "@/mixins/MultishortArray";
import moment from "moment";

export default {
  name: "CreatePo",
  props: ["id"],
  mixins: [CurrencyFormat,shortingArray],
  components: {
    Informasi,
    DetailPembelian,
    Approval,
  },
  data() {
    return {
      current: 0,
      steps: [
        {
          title: "Informasi",
          content: "Informasi"
        },
        {
          title: "DetailPembelian",
          content: "DetailPembelian"
        },
        {
          title: "Approval",
          content: "Approval",
        },
      ],
      mode: "Create",
      isDraftEdited: false,
      collectData: {},
      listPembelian: [],
      postData: new FormData(),
      postJson: {},
      editData: {},
      btnLoading: false,
      rounding: {
        value : 0,
        ppdtl : ""
      },
    };
  },
  computed: {
    ...mapGetters(["getAuth", "getStandartFormatDate"]),
    initialListItem() {
      let data = [];
      let hargaTotal = 0;
      if (this.mode === "Edit") {
        this.listPembelian.forEach(item => {
          hargaTotal = item.values.jumlah * item.values.harga;
          const values = item.values;
          data = [...data, { hargaTotal: hargaTotal, values }];
        });
      } else {
        data = this.listPembelian;
        this.collectData.listBeli.forEach(item => {
          hargaTotal = item.jumlah * item.harga;
          data = [
            ...data,
            {
              hargaTotal: hargaTotal,
              values: item
            }
          ];
        });
      }
      return data;
    },
    stepProps: function() {
      if (this.mode === "Edit") {
        if (this.steps[this.current].content === "Informasi") {
          return {
            data: this.collectData.informasi,
            listPembelian: this.initialListItem,
            mode: this.mode,
            isDraftEdited: this.isDraftEdited
          };
        } else if (this.steps[this.current].content === "DetailPembelian") {
          return {
            listPembelian: this.initialListItem,
            keuangan: this.keuangan,
            informasi : this.collectData.informasi,
            shipping : this.collectData.informasi.shipping,
            check_shipping : this.collectData.informasi.check_shipping,
            tax: this.collectData.informasi.tax,
            mode: "Edit",
            isDraftEdited: this.isDraftEdited,
            mata_uang: this.collectData.selectedPP[0] ? this.collectData.selectedPP[0].currency : null,
            id_pp: this.collectData.informasi.id_pp,
            jenis_anggaran: this.collectData.informasi.jenis_anggaran,
            kurs: this.kurs,
          };
        } else{
          return {
            collectData: this.collectData,
            mode: this.mode,
            isDraftEdited: this.isDraftEdited,
            listAppr: this.collectData.approval,
            id: this.id
          };
        }
      } else {
        if (this.steps[this.current].content === "Informasi") {
          return {
            data: this.collectData.informasi,
            listPembelian: this.listPembelian,
            mode: this.mode,
            isDraftEdited: this.isDraftEdited,
          };
        } else if (this.steps[this.current].content === "DetailPembelian") {
          return {
            informasi : this.collectData.informasi,
            listPembelian: this.listPembelian,
            shipping : this.collectData.informasi.shipping,
            check_shipping : this.collectData.informasi.check_shipping,
            tax: this.collectData.informasi.tax,
            mode: this.mode,
            isDraftEdited: this.isDraftEdited,
            mata_uang: this.collectData.selectedPP[0].currency,
            id_pp: this.collectData.informasi.id_pp,
            jenis_anggaran: this.collectData.informasi.jenis_anggaran,
            kurs: this.kurs,
          };
        } else {
          return {
            collectData: this.collectData,
            listAppr: this.collectData.approval,
            mode: this.mode,
            isDraftEdited: this.isDraftEdited,
            id: this.id
          };
        }
      }
    },
    stepRef: function() {
      //console.log(this.steps[this.current].content)
      if (this.steps[this.current].content === "Informasi") {
        return "refInformasi";
      } else if (this.steps[this.current].content === "DetailPembelian") {
        return "refDetailPembelian";
      }else{
        return "refApproval";
      }
    }
  },
  created() {
    if (this.id) {
      this.mode = "Edit";
      if(this.$route.meta && this.$route.meta.isDraftEdited){
        this.isDraftEdited = this.$route.meta.isDraftEdited
      }
      this.fetchDetail();
    }
  },
  methods: {
    moment,
    next() {
      if (this.steps[this.current].content === "Informasi") {
        this.$refs.refInformasi.handleRef();
      } else if (this.steps[this.current].content === "DetailPembelian") {
        this.$refs.refDetailPembelian.handleRef();
      } else {
        this.$refs.refApproval.handleRef();
      }
    },
    prev() {
      //console.log(this.steps[this.current].content)
      if (this.steps[this.current].content === "DetailPembelian"){
        this.$refs.refDetailPembelian.resetForm();
      }
      this.current--;
    },
    validate() {
      this.$refs.refApproval.handleRef();
    },
    valueFromChild(value) {
      if (this.steps[this.current].content === "Informasi") {
        if (this.mode === "Create") {
          this.collectData.informasi = JSON.parse(
            JSON.stringify(value.informasi)
          );
          this.isDraftEdited = true
        }

        this.collectData.informasi = JSON.parse(
          JSON.stringify(value.informasi)
        );

        this.collectData.selectedPP = value.selectedPP;
        this.kurs = value.selectedPP.length > 0 ? (value.selectedPP[0].kurs ? value.selectedPP[0].kurs : 0) : undefined;

        if (this.mode=="Edit" && !this.kurs){
          this.kurs = this.keuangan.kurs;
        }

        this.current++;
      } else if (this.steps[this.current].content === "DetailPembelian") {
        this.collectData.detailBeli = JSON.parse(
          JSON.stringify(value.detailBeli)
        );
        this.collectData.emptyValidator = value.emptyValidator;
        this.collectData.grandTotal = value.grandTotal;
        this.rounding.value = value.rounding.value;
        this.rounding.ppdtl = value.rounding.ppdtl;
        this.getApproval();
      } else {
        this.collectData.informasi.catatan = value.note;
        if (this.mode === "Edit") {
          this.confirmMessage("confirm-edit");
        }else{
          this.confirmMessage("confirm-save");
        }
      }
    },
    getListPembelian(item) {
      this.listPembelian = [
        ...this.listPembelian,
        JSON.parse(JSON.stringify(item))
      ];
      //console.log("getListPembelian",this.listPembelian)
      this.$refs.refDetailPembelian.recountingBalance(this.listPembelian,"add")
    },
    getUpdatePembelian(item) {
      this.listPembelian = item;
      this.$refs.refDetailPembelian.recountingBalance(this.listPembelian,"add")
      this.listPembelian = this.ArrshortMultiCol(this.listPembelian, {
        pp_kode_anggaran: "asc",
      });
    },
    setSubmitForm() {
      if (this.mode === "Edit") {
        this.postData = new FormData();
        this.postData.append("tlc", this.getAuth.username);
        this.postData.append("id_manifest", this.collectData.informasi.id_po);
        this.postData.append(
          "id_supplier",
          this.collectData.informasi.id_supplier.constructor === Object ? this.collectData.informasi.id_supplier.id_supplier :  this.collectData.informasi.id_supplier
        );
        this.postData.append("deskripsi", this.collectData.informasi.deskripsi?this.collectData.informasi.deskripsi:'');
        this.postData.append("lokasi", this.collectData.informasi.lokasi);
        this.postData.append("inc_qc", this.collectData.informasi.inc_qc);
        this.postData.append("tax", this.collectData.informasi.tax);
        this.postData.append("shipping", this.collectData.informasi.shipping);
        this.postData.append(
          "target_selesai",
          this.collectData.informasi.target_selesai
        );
        this.postData.append("catatan", this.collectData.informasi.catatan ? 
          this.collectData.informasi.catatan : '');

        if (this.collectData.informasi.dokumen.includes("COC")) {
          this.postData.append("coc", "1");
        } else {
          this.postData.append("coc", "0");
        }

        if (this.collectData.informasi.dokumen.includes("TR")) {
          this.postData.append("test_report", "1");
        } else {
          this.postData.append("test_report", "0");
        }

        if (this.collectData.informasi.dokumen.includes("CPD")) {
          this.postData.append("cpd", "1");
        } else {
          this.postData.append("cpd", "0");
        }

        this.postData.append("tax_bearer", this.collectData.informasi.tax_bearer);
        this.postData.append("tax_transaction", this.collectData.informasi.tax_transaction);
        this.postData.append("value_po",this.collectData.grandTotal);

        let indexToRounding = 0;
        this.collectData.detailBeli.forEach((data, index) => {
          this.postData.append(
            "nama_barang[" + index + "]",
            data.values.nama_barang
          );
          this.postData.append("item_pn[" + index + "]", data.values.item_pn ? data.values.item_pn :'');
          this.postData.append("jumlah[" + index + "]", data.values.jumlah);
          this.postData.append("satuan[" + index + "]", data.values.satuan);
          this.postData.append("harga[" + index + "]", data.values.harga);
          // this.postData.append("kategori[" + index + "]", data.values.kategori);
          this.postData.append("hargaTotal[" + index + "]", data.values.hargaTotal);
          this.postData.append("is_item[" + index + "]", data.values.is_item);
          this.postData.append("used_for[" + index + "]", data.values.used_for);
          this.postData.append("id_pp_dtl[" + index + "]", data.values.selectedPPdtl);
          this.postData.append("unit_price[" + index + "]", data.values.cur_type);
          this.postData.append("type_item[" + index + "]", data.values.type_item);
          this.postData.append("catatan_dtl[" + index + "]", data.values.catatan_dtl);
          this.postData.append("isinventaris[" + index + "]", data.values.isinventaris ? data.values.isinventaris : undefined);
          this.postData.append("tax_type[" + index + "]", data.values.tax_type);
          this.postData.append("tax_bearer[" + index + "]", data.values.tax_bearer);

          // insert data jika ada rounding
          if(this.rounding.value>0){
            indexToRounding = indexToRounding+1;
            this.postData.append("nama_barang[" + indexToRounding + "]", "Rounding Value PO");
            this.postData.append("item_pn[" + indexToRounding + "]", null);
            this.postData.append("jumlah[" + indexToRounding + "]", null);
            this.postData.append("satuan[" + indexToRounding + "]", null);
            this.postData.append("harga[" + indexToRounding + "]", this.rounding.value);
            this.postData.append("hargaTotal[" + indexToRounding + "]", this.rounding.value);
            this.postData.append("is_item[" + indexToRounding + "]", "no");
            this.postData.append("used_for[" + indexToRounding + "]", "4");
            this.postData.append("id_pp_dtl[" + indexToRounding + "]", this.rounding.ppdtl);
            this.postData.append("unit_price[" + indexToRounding + "]", "currency");
            this.postData.append("type_item[" + indexToRounding + "]", "0");
          }
        });
      } else {
        this.postData = new FormData();
        this.postData.append("tlc", this.getAuth.username);
        this.postData.append(
          "tgl_po",
          moment(this.collectData.informasi.tgl_buat).format(
            this.getStandartFormatDate
          )
        );
        this.postData.append("no_pp", this.collectData.informasi.no_pp);
        this.postData.append("id_pp", this.collectData.informasi.id_pp);
        this.postData.append(
          "id_supplier",
          this.collectData.informasi.id_supplier
        );
        this.postData.append("deskripsi", this.collectData.informasi.deskripsi?this.collectData.informasi.deskripsi:'');
        this.postData.append("lokasi", this.collectData.informasi.lokasi);
        this.postData.append("inc_qc", this.collectData.informasi.inc_qc);
        this.postData.append("tax", this.collectData.informasi.tax);
        this.postData.append("shipping", this.collectData.informasi.shipping);
        this.postData.append("catatan", this.collectData.informasi.catatan ? 
          this.collectData.informasi.catatan : '');
        this.postData.append("bod", this.collectData.informasi.bod);
        this.postData.append(
          "target_selesai",
          this.collectData.informasi.target_selesai
        );

        if (this.collectData.informasi.dokumen.includes("COC")) {
          this.postData.append("coc", "1");
        } else {
          this.postData.append("coc", "0");
        }

        if (this.collectData.informasi.dokumen.includes("TR")) {
          this.postData.append("test_report", "1");
        } else {
          this.postData.append("test_report", "0");
        }

        if (this.collectData.informasi.dokumen.includes("CPD")) {
          this.postData.append("cpd", "1");
        } else {
          this.postData.append("cpd", "0");
        }

        this.postData.append("tax_bearer", this.collectData.informasi.tax_bearer);
        this.postData.append("tax_transaction", this.collectData.informasi.tax_transaction);
        this.postData.append("value_po",this.collectData.grandTotal);

        let indexToRounding = 0;
        this.collectData.detailBeli.forEach((data, index) => {
          this.postData.append(
            "nama_barang[" + index + "]",
            data.values.nama_barang
          );
          this.postData.append("item_pn[" + index + "]", data.values.item_pn ? data.values.item_pn : '');
          this.postData.append("jumlah[" + index + "]", data.values.jumlah);
          this.postData.append("satuan[" + index + "]", data.values.satuan);
          this.postData.append("harga[" + index + "]", data.values.harga);
          this.postData.append("hargaTotal[" + index + "]", data.values.hargaTotal);
          this.postData.append("is_item[" + index + "]", data.values.is_item);
          this.postData.append("used_for[" + index + "]", data.values.used_for);
          this.postData.append("id_pp_dtl[" + index + "]", data.values.selectedPPdtl ? data.values.selectedPPdtl : '');
          this.postData.append("unit_price[" + index + "]", data.values.cur_type);
          // this.postData.append("kategori[" + index + "]", data.values.kategori);
          this.postData.append("type_item[" + index + "]", data.values.type_item);
          this.postData.append("catatan_dtl[" + index + "]", data.values.catatan_dtl ? data.values.catatan_dtl : '');
          this.postData.append("isinventaris[" + index + "]", data.values.isinventaris ? data.values.isinventaris : undefined);
          this.postData.append("tax_type[" + index + "]", data.values.tax_type);
          this.postData.append("tax_bearer[" + index + "]", data.values.tax_bearer);
          indexToRounding = index;
        });

        // insert data jika ada rounding
        if(this.rounding.value>0){
          indexToRounding = indexToRounding+1;
          this.postData.append("nama_barang[" + indexToRounding + "]", "Rounding Value PO");
          this.postData.append("item_pn[" + indexToRounding + "]", null);
          this.postData.append("jumlah[" + indexToRounding + "]", null);
          this.postData.append("satuan[" + indexToRounding + "]", null);
          this.postData.append("harga[" + indexToRounding + "]", this.rounding.value);
          this.postData.append("hargaTotal[" + indexToRounding + "]", this.rounding.value);
          this.postData.append("is_item[" + indexToRounding + "]", "no");
          this.postData.append("used_for[" + indexToRounding + "]", "4");
          this.postData.append("id_pp_dtl[" + indexToRounding + "]", this.rounding.ppdtl);
          this.postData.append("unit_price[" + indexToRounding + "]", "currency");
          this.postData.append("type_item[" + indexToRounding + "]", "0");
        }
      }

      this.postData.append("id_po", this.collectData.informasi.id_po);
    },
    submit() {
      if(this.collectData.emptyValidator==0){
        this.displayMessage("empty-phurcaselist")
        return
      }


      this.setSubmitForm();
      this.btnLoading = true;
      let method = "";
      let data = "";
      let url = "";
      if (this.mode === "Create") {
        method = "post";
        data = this.postData;
        url = this.$serviceUrl + "po/v3";
      } else {
        method = "post";
        data = this.postData;
        url = this.$serviceUrl + (this.isDraftEdited ? "po/v3" : "po/edit_v2");
      }

      axios({
        method: method,
        url: url,
        processData: false,
        data: data,
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password
        },
        headers: {
          "Content-Type": "application/json",
          "X-API-KEY": this.getAuth.apikey
        }
      })
        .then(response => {
          if (this.mode === "Create") {
            this.displayMessage("success-save");
          } else {
            this.displayMessage("success-edit");
          }
          this.btnLoading = false;
          this.current = 0;
          this.$router.push({ name: "po" });
        })
        .catch(err => {
          let response = Object.assign({}, err.response);
          if (response.data.message.includes("Saldo PP tidak cukup")) {
            let sisa = this.formatCurrency(
                  this.collectData.selectedPP[0].currency,
                  response.data.message.replace("Saldo PP tidak cukup!", "")
                );
            this.displayMessageValue("pp-notenough",sisa);
          }else if(response.data.message){
            this.displayMessageValue("error-other",response.data.message);
          } else {
            let responses = Object.assign({}, err.response.data);
            console.log(responses);
            this.displayMessageValue("error",responses);
          }
          this.btnLoading = false;
        });
    },
    fetchDetail() {
      let url = "po/po_Detil_v2"
      let param = {
        id_manifest: this.id,
        tlc: this.getAuth.username
      }
      if(this.isDraftEdited) {
        url = 'po/dtl_draft'
        param ={id_po: this.id}
      }
      axios({
        method: "get",
        url: this.$serviceUrl + url,
        params: param,
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey
        }
      })
        .then(response => {
          if(!response.data.informasi.id_po){
            this.$router.push({
              name: "po",
              params: {},
            });
            return
          }

          if (parseInt(response.data.informasi.tax) >= 0) {
            response.data.informasi.check_tax = true;
          }

          if (parseInt(response.data.informasi.shipping) >= 0) {
              response.data.informasi.check_shipping = true;
          }

          this.collectData = {
            informasi: response.data.informasi
          };

          this.keuangan = JSON.parse(JSON.stringify(response.data.keuangan[0]));

          response.data.detail_po.forEach(item => {
            if(item.nama_barang!='Rounding Value PO'){
              this.listPembelian = [...this.listPembelian, { values: item }];
            }
          });
        })
        .catch(err => {
          let responses = Object.assign({}, err.response.data);
          this.displayMessageValue("error",responses);
        });
    },
    setListPembelianEmpty(){
      this.listPembelian = [];
    },
    async getApproval(){
      let params = null;
      if (this.mode=="Create" || this.isDraftEdited){
        params = {
          tlc : this.getAuth.username,
          id_pp : this.collectData.informasi.id_pp,
          value_po : this.collectData.grandTotal
        }
      }else{
        params = {
          tlc : this.getAuth.username,
          id_pp : this.collectData.informasi.id_pp,
          value_po : this.collectData.grandTotal,
          id_po : this.id,
        }
      }
      await axios({
        method: 'get',
        url: this.$serviceUrl + "po/approval",
        processData: false,
        params: params,
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password
        },
        headers: {
          "Content-Type": "application/json",
          "X-API-KEY": this.getAuth.apikey
        }
      })
        .then(response => {
          this.collectData.approval=response.data.data;
          this.current++;
        })
        .catch(err => {
          let responses = Object.assign({}, err.response);
          this.displayMessageValue("error", responses);
        });
    },
    setLoadingBtnNext(val){
      this.btnLoading = val
    }
  },
  mounted() {
    Event.$on("loadingBtnNext", this.setLoadingBtnNext);
    Event.$on("poData", this.valueFromChild);
    Event.$on("listPembelian", this.getListPembelian);
    Event.$on("emptylistPembelian", this.setListPembelianEmpty);
    Event.$on("updateList", this.getUpdatePembelian);
    Event.$on("confirmMessageReturn", this.submit);
  },
  beforeDestroy() {
    Event.$off("loadingBtnNext", this.setLoadingBtnNext);
    Event.$off("poData", this.valueFromChild);
    Event.$off("listPembelian", this.getListPembelian);
    Event.$off("emptylistPembelian", this.setListPembelianEmpty);
    Event.$off("updateList", this.getUpdatePembelian);
    Event.$off("confirmMessageReturn", this.submit);
  }
};
</script>

<style>
</style>